// @flow

import type { FullState } from '../../../types';
import type { TLDs } from '../../types/index';

export const selectAllTLDs = (state: FullState): TLDs =>
  state.domainSuggest.tlds;
